import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild, } from '@angular/core';
import { Subscription } from 'rxjs';
import { AudioService } from 'src/app/services/audio.service';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements AfterViewInit, OnDestroy, OnInit {
  @Input() src: string;
  @Input() autoPlay: boolean = true;
  @ViewChild('player') player: ElementRef;
  @ViewChild('timeline') timeline: ElementRef;
  @ViewChild('volumeSlider') volumeSlider: ElementRef;
  @ViewChild('volumePercentage') volumePercentage: ElementRef;
  @ViewChild('progressBar') progressBar: ElementRef;
  @ViewChild('tooglePlayEl') tooglePlayEl: ElementRef;
  @ViewChild('volume') volume: ElementRef;
  audioSubscription: Subscription;
  audio;
  interval;
  audioId = Math.random();

  constructor(private audioService: AudioService, @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.audio = new Audio(this.src);
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.audio.addEventListener(
        "loadeddata",
        () => {
          this.player.nativeElement.querySelector(".time .length").textContent = this.getTimeCodeFromNum(
            this.audio.duration
          );
          this.audio.volume = .75;
        },
        false
      );

      this.interval = setInterval(() => {
        this.progressBar.nativeElement.style.width = this.audio.currentTime / this.audio.duration * 100 + "%";
        this.player.nativeElement.querySelector(".time .current").textContent = this.getTimeCodeFromNum(
          this.audio.currentTime
        );
      }, 500);

      if(this.autoPlay) {
        this.tooglePlay();
      }

      this.audioSubscription = this.audioService.stopAudioListener().subscribe(id => {
        if (this.audioId === id) {
          this.tooglePlayEl.nativeElement.classList.remove("pause");
          this.tooglePlayEl.nativeElement.classList.add("play");
          this.audio.pause();
        }
      });
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      this.audio.pause();
      clearInterval(this.interval);
      this.audioSubscription.unsubscribe();
    }
  }

  tooglePlay() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.audio.paused) {
        this.audioService.addAudio(this.audioId);
        this.tooglePlayEl.nativeElement.classList.remove("play");
        this.tooglePlayEl.nativeElement.classList.add("pause");
        this.audio.play();
      } else {
        this.tooglePlayEl.nativeElement.classList.remove("pause");
        this.tooglePlayEl.nativeElement.classList.add("play");
        this.audio.pause();
      }
    }
  }

  timelineClick(e) {
    if (isPlatformBrowser(this.platformId)) {
      const timelineWidth = window.getComputedStyle(this.timeline.nativeElement).width;
      const timeToSeek = e.offsetX / parseInt(timelineWidth) * this.audio.duration;
      this.audio.currentTime = timeToSeek;
    }
  }

  volumeSliderClick(e) {
    if (isPlatformBrowser(this.platformId)) {
      const sliderWidth = window.getComputedStyle(this.volumeSlider.nativeElement).width;
      const newVolume = e.offsetX / parseInt(sliderWidth);
      this.audio.volume = newVolume;
      this.volumePercentage.nativeElement.style.width = newVolume * 100 + '%';
      this.audio.muted = false;
    }
  }

  volumeClick() {
    if (isPlatformBrowser(this.platformId)) {
      this.audio.muted = !this.audio.muted;
    }
  }

  getTimeCodeFromNum(num: number) {
    if (isPlatformBrowser(this.platformId)) {
      let seconds = Math.trunc(num);
      const minutes = Math.trunc(seconds / 60);
      seconds -= minutes * 60;
      return `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
    }
  }

}
